import hubProxy from './assets/ts/signalr';
import restful from './assets/ts/restful';

let isNavigating = false

export default class Hubs {
    init() {
        let self = this;
        $.extend(hubProxy.client, {
            sessionEnd: function (isAnnonymous) {
                console.log("signalR" + isAnnonymous);
                if (isAnnonymous == false)
                    restful.get("authentication/status", {})
                        .done(userStatus => {
                            console.log("done" + userStatus);
                        })
                        .fail(err => {
                            self.sessionEnd(isAnnonymous);
                        });
            },
            refresh: function () {
                console.log("refresh...");
                let self = this;
                function innerRefresh() {
                    if (isNavigating)
                        return;

                    isNavigating = true

                    setTimeout(() => {
                        //window.location = payload.currentUrl + `?redirect=/home/private}`;
                        console.log("innerRefresh , window.location in refresh called")
                    }, 1500)
                }

                if ($.browser.mozilla) {
                    setTimeout(() => innerRefresh(), 1000);
                } else {
                    innerRefresh();
                }
            }
        });
        $.extend(hubProxy.client, {
            onMessageRecived: function (messageCount) {
                //alert(messageCount); 
                console.log("onMessageRecived called");
                payload.unSeenMessagesCount = messageCount;

                if (messageCount == 0) {
                    $('.messageCount').removeClass("label-danger");
                    $('.messageCount').text("");
                }
                else {
                    $('.messageCount').addClass("label-danger");
                    $('.messageCount').text(messageCount);
                }
                var dir = payload.currentLocale.IsRightToLeft == true ? 'rtl' : 'ltr';
                var message = "\r\n" + i18n.$t('messages_receive_notification');
                var options = {
                    icon: "./dist/bpms-notif.png",
                    dir: dir,
                    body: message
                }

                Notification.requestPermission(function () {
                    var instance = new Notification("", options);
                    instance.onclick = function (e) {
                        window.focus();
                        router.push({
                            name: 'message-grid'
                            , params: {
                                isReceivedMessage: "true"
                            }
                        });
                    }
                    setTimeout(function () {
                        instance.close();
                    }, 4000);
                });
            }
        });

        $.extend(hubProxy.client, {
            fileEdited: function (pageInstanceId, fileId, groupId, changeMode) {
                if (typeof global.attachmentFileChanged === "function") {
                    global.attachmentFileChanged(pageInstanceId, fileId, groupId, changeMode);
                }
            },
            fileEditFailed: function (pageInstanceId, result, errorMsg) {
                if (typeof global.attachmentFileChangingFailed === "function") {
                    global.attachmentFileChangingFailed(pageInstanceId, result, errorMsg);
                }
            }
        });
        $(window).on('beforeunload', (e) => {
            isNavigating = true
            return undefined
        });

        hubProxy.connection.stateChanged((state) => {
            if (state.newState == $.signalR.connectionState.reconnecting || state.newState == $.signalR.connectionState.disconnected) {
                restful.get("authentication/status", {})
                    .done(userStatus => {
                        this.sessionEnd(false);
                    })
                    .fail(err => {
                        if (err.status === 503)
                            this.sessionEnd(false);
                    });
            }

            $.connection.hub.disconnected(this.sessionEnd);
        });

        $.extend(hubProxy.client, {
            forceSessionEnd: function () {
                console.log("forceSessionEnd called window.location.reload");
                isNavigating = true;
                ///window.location.reload()
            }
        });
    }

    sessionEnd(isAnonymous) {
        let self = this;
        function inner() {
            if (isNavigating)
                return;

            isNavigating = true

            setTimeout(() => {
                console.log("sessionEnd , inner window.location called");
                //window.location = payload.currentUrl + `?redirect=/home/private${encodeURIComponent(window.location.hash)}`;
            }, 15000)
        }

        if ($.browser.mozilla) {
            setTimeout(() => inner(), 1000);
        } else {
            inner();
        }
    }
}
